<template>
  <Modal v-model="show" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="insert_edit_pop" width="1100">
    <div class="transfer_template">
      <div class="font_style_set"><span class="span_must">*</span>IVR名称</div>
      <div class="transfer_input">
        <Input v-model="name" placeholder="请输入IVR名称" title="IVR名称"/>
      </div>
    </div>
    <!--buttons-->
    <div class="btn_template" style="margin-top: 15px">
      <Button type="error" class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: "CopyIvrPop",
    props: {
      ivrId: String | Number,
      showCopyIvr:Boolean,
      ivrName:String
    },
    data() {
      return {
        title: '复制IVR流程',
        show: false,
        name:'',
        saveDisabled:false,
        flag:false
      }
    },
    methods:{
      cancel() {
        this.$emit('closeshowCopyIvrPop',false)
      },
      save() {
        this.saveDisabled=true;
        let that = this
        if (!this.name) {
          this.$Message.warning("IVR名称不能为空！");
          return false;
        }
        //编辑
        if (this.ivrId && this.flag) {
          let param = {
            id:this.ivrId,
            menuId:'3_5-3-4',
            ivrName:this.name,
            journalType:'CTI配置=>IVR设置=>编辑IVR',
          };
          this.$http.post("ivrDesign/doSaveIvr.json",param).then(res=>{
            let response = res.data
            that.saveDisabled=false;
            if (response.flag !== '666') {
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return
            }
            that.$Message.success('操作成功！');
            that.$emit('closeshowCopyIvrPop',true);
          });
        }
        //复制
        if(this.ivrId && !this.flag){
          let param = {
            id:this.ivrId,
            menuId:'3_5-3-2',
            ivrName:this.name,
            journalType:'CTI配置=>IVR设置=>IVR流程复制',
          };
          this.$http.post("ivrDesign/doCopyIvr.json",param).then(res=>{
            let response = res.data
            that.saveDisabled=false;
            if (response.flag !== '666') {
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return
            }
            that.$Message.success('复制成功！')
            that.$emit('closeshowCopyIvrPop',true);
          });
        }
      },
    },
    watch:{
      showCopyIvr:{
        handler(value) {
          this.name = "";
          this.flag = false;
          this.title = "复制语音导航流程";
          this.saveDisabled=false;
          this.show = value;
          if(this.ivrName){
              this.name = this.ivrName;
              this.title = "编辑语音导航";
              this.flag = true;
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/CopyIvrPop.vue